import React from "react"

import { Container } from "./styles"

const TextWithMedia = ({ elRef, element }) => {
  const { trackingId: componentId, promotionalUnit, theme, below, isAdvertisement } = element

  if (!promotionalUnit) {
    return null
  }

  const hasMedia = Boolean(promotionalUnit.media)
  const mediaType = promotionalUnit.media?.internal.type
  const hasImage = hasMedia && mediaType === "ContentfulImage"
  const hasVideo = hasMedia && mediaType === "ContentfulVideo"

  return (
    <Container
      elRef={elRef}
      component={promotionalUnit}
      mediaPosition={promotionalUnit.mediaPosition}
      below={below}
      sideBySide={below || !hasVideo}
      isAdvertisement={Boolean(isAdvertisement)}
      hasPreheading={Boolean(promotionalUnit.preHeadingText)}
      hasImage={hasImage}
      hasVideo={hasVideo}
      hasSignupForm={Boolean(promotionalUnit.signupForm)}
      trackingId={componentId}
      componentOverrideTheme={theme}
      isPromotionalPlacement
    />
  )
}

export default TextWithMedia
